(function () {
  'use strict';
  var adding = new Set();
  function pretty(text) { return String(text || '').replace(/'/g, '′').replace(/"/g, '″').replace(/ x /g, ' × '); }
  function rememberAdded() { try { sessionStorage.setItem('rugi-extra-pad-added', '1'); } catch (error) {} }

  function init(root) {
    if (root.dataset.ready || !window.RugiPadSizing) return;
    root.dataset.ready = 'true';
    var select = root.querySelector('[data-rugi-protection-size]');
    var button = root.querySelector('[data-rugi-protection-add]');
    var status = root.querySelector('[data-rugi-protection-status]');
    var quantity = root.querySelector('[data-rugi-protection-quantity]');
    var size = window.RugiPadSizing.fitFromData(root, root.dataset.rugLabel);
    var cut = window.RugiPadSizing.cutSize(size);
    var purpose = root.querySelector('[data-rugi-protection-purpose]');
    var rugName = window.RugiPadSizing.shortName(root.dataset.rugTitle, root.dataset.rugMaterial);
    var rugLine = root.querySelector('[data-rugi-protection-rug]');
    if (rugLine) rugLine.textContent = rugName + (size && size.measured ? ' · ' + window.RugiPadSizing.describe(size) : '');
    window.RugiPadSizing.constrain(select, cut);
    var options = Array.from(select.options).filter(function (o) { return o.value; }).map(function (o) {
      return { id: o.value, price: Number(o.dataset.price), size: window.RugiPadSizing.parse(o.dataset.title), disabled: o.disabled };
    });
    var match = window.RugiPadSizing.choose(options, cut);
    if (match) select.value = match.id;
    function validSelection() {
      var selected = select.selectedOptions[0];
      var count = quantity ? Number(quantity.value) : Number(root.dataset.rugQuantity) || 1;
      return !!(selected && selected.value && !selected.disabled && Number.isInteger(count) && count > 0 && (!cut || window.RugiPadSizing.covers(window.RugiPadSizing.parse(selected.dataset.title), cut)));
    }
    function updateFit() {
      var selected = select.selectedOptions[0];
      var smaller = cut && selected && selected.value && !window.RugiPadSizing.covers(window.RugiPadSizing.parse(selected.dataset.title), cut);
      root.querySelector('[data-rugi-protection-cut-label]').textContent = cut && size.measured ? 'We’ll cut your pad to' : 'Confirm your rug’s actual size';
      root.querySelector('[data-rugi-protection-cut]').textContent = cut && size.measured ? pretty(window.RugiPadSizing.describe(cut)) : 'Measurements needed';
      root.querySelector('[data-rugi-protection-fit]').textContent = smaller ? 'This stock size is too small for this cut. For another rug, use the option below.' : cut && size.measured ? '1½″ inside every edge — 3″ less in both width and length.' : 'We’ll confirm measurements before cutting.';
      var price = selected && selected.value ? selected.textContent.split('·').pop().trim() : '';
      button.textContent = price ? 'Add pad · ' + price : 'Add pad';
      button.disabled = !validSelection();
    }
    updateFit();
    select.addEventListener('change', updateFit);
    if (purpose) purpose.addEventListener('change', updateFit);
    if (quantity) quantity.addEventListener('input', updateFit);
    button.addEventListener('click', async function () {
      if (!validSelection() || button.disabled || adding.has(root.dataset.rugKey)) return;
      adding.add(root.dataset.rugKey);
      button.disabled = true;
      status.textContent = 'Adding your rug pad…';
      try {
        await saveNote();
        var other = purpose && purpose.value === 'other';
        var properties = other ? {'For rug':'Another rug (leave uncut)', 'Cut to fit':'Leave uncut; for another rug'} : { 'For rug': rugName, '_rugi_rug_key': root.dataset.rugKey };
        if (!other) {
          properties['Cut to fit'] = cut && size.measured ? window.RugiPadSizing.describe(cut) : 'Confirm actual rug measurements before cutting';
          if (size && size.measured) properties['Rug measured size'] = window.RugiPadSizing.describe(size);
          properties['Edge inset'] = '1.5 inches on every edge';
          if (root.dataset.rugSku) properties['Rug ID'] = root.dataset.rugSku;
        }
        var response = await fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(select.value), quantity: quantity ? Number(quantity.value) : Number(root.dataset.rugQuantity) || 1, properties: properties }] })
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The pad could not be added. Please try again.');
        status.textContent = 'Rug pad added.'; rememberAdded();
        root.querySelectorAll('button,select').forEach(function (control) { control.disabled = true; });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        if (window.theme.pageType === 'cart') location.reload();
      } catch (error) {
        status.textContent = error.message;
        button.disabled = !validSelection();
      } finally {
        adding.delete(root.dataset.rugKey);
      }
    });
  }
  async function saveNote() {
    var note = document.querySelector('.cart-recap textarea[name="note"]');
    if (!note) return;
    var response = await fetch((window.Shopify.routes.root || '/') + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note.value})});
    if (!response.ok) throw new Error('Your order note could not be saved. Please try again.');
  }
  function readExtraRequest(root) {
    var S = window.RugiPadSizing;
    var select = root.querySelector('[data-extra-size]'), option = select.selectedOptions[0];
    var custom = root.querySelector('[data-extra-mode]').value === 'custom';
    var quantity = Number(root.querySelector('[data-extra-quantity]').value);
    var stock = option && S.parse(option.dataset.title), fit = null, cut = null;
    if (custom) {
      var width = S.parseDimension(root.querySelector('[data-extra-width]').value.trim());
      var length = stock && stock.shape === 'round' ? width : S.parseDimension(root.querySelector('[data-extra-length]').value.trim());
      fit = width && length ? {w:Math.min(width,length),l:Math.max(width,length),shape:stock ? stock.shape : 'rect',measured:true} : null;
      cut = S.cutSize(fit);
    }
    var valid = !!(option && option.value && !option.disabled && Number.isInteger(quantity) && quantity > 0 && (!custom || cut && S.covers(stock, cut)));
    var properties = {'For rug':'Additional rug pad'};
    if (custom && cut) {
      properties['Rug measured size'] = S.describe(fit);
      properties['Cut to fit'] = S.describe(cut);
      properties['Edge inset'] = '1.5 inches on every edge';
    } else properties['Cut to fit'] = 'Exact stock size; leave uncut';
    return {valid:valid, custom:custom, fit:fit, cut:cut, stock:stock, quantity:quantity, id:option && option.value, properties:properties};
  }
  function initExtra(root) {
    if (root.dataset.ready || !window.RugiPadSizing) return;
    root.dataset.ready = 'true';
    var S=window.RugiPadSizing, select=root.querySelector('[data-extra-size]'), mode=root.querySelector('[data-extra-mode]');
    var body=root.querySelector('[data-extra-body]'), status=root.querySelector('[data-extra-status]'), button=root.querySelector('[data-extra-add]'), pending=false;
    try { if(sessionStorage.getItem('rugi-extra-pad-added')==='1') root.querySelector('[data-extra-question]').textContent='Do you need another pad?'; } catch(error) {}
    root.querySelector('[data-extra-yes]').addEventListener('click',function(){body.hidden=false;mode.focus();});
    root.querySelector('[data-extra-no]').addEventListener('click',function(){body.hidden=true;var note='A rug pad is optional—we simply trust Durahold Plus to help protect your rug.';status.textContent=note;setTimeout(function(){if(status.textContent===note)status.textContent='';},7000);});
    function update(recommend) {
      var request=readExtraRequest(root);
      if(recommend && request.custom && request.cut) {
        var options=Array.from(select.options).filter(function(o){return o.value;}).map(function(o){return{id:o.value,size:S.parse(o.dataset.title),price:Number(o.dataset.price),disabled:o.disabled};});
        var match=S.choose(options,request.cut);if(match)select.value=match.id;
        request=readExtraRequest(root);
      }
      root.querySelector('[data-extra-measurements]').hidden=!request.custom;
      var round=request.stock&&request.stock.shape==='round';
      root.querySelector('[data-extra-width-label]').textContent=round?'Rug diameter':'Rug width';
      root.querySelector('[data-extra-length-field]').hidden=round;
      root.querySelector('[data-extra-cut]').textContent=request.custom?(request.cut?'Finished pad: '+pretty(S.describe(request.cut))+(request.valid?' — 1½″ inside every edge.':' · Select a stock size large enough for this cut.'):'Enter both actual rug measurements to see the finished cut and recommended stock size.'):'Exact stock size, supplied uncut.';
      var price=select.selectedOptions[0]&&select.value?select.selectedOptions[0].textContent.split('·').pop().trim():'';
      button.textContent=price?'Add pad · '+price:'Add pad';button.disabled=pending||!request.valid;
    }
    select.addEventListener('change',function(){update(false);});mode.addEventListener('change',function(){update(true);});
    root.querySelectorAll('[data-extra-width],[data-extra-length]').forEach(function(input){input.addEventListener('input',function(){update(true);});});
    root.querySelector('[data-extra-quantity]').addEventListener('input',function(){update(false);});
    button.addEventListener('click',async function(){
      var request=readExtraRequest(root);if(pending||!request.valid)return;pending=true;button.disabled=true;status.textContent='Adding your pad…';
      try {
        await saveNote();
        var response=await fetch((window.Shopify.routes.root||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(request.id),quantity:request.quantity,properties:request.properties}]})});
        var result=await response.json();if(!response.ok)throw new Error(result.description||'This pad could not be added. Please try again.');
        rememberAdded();body.hidden=true;root.querySelector('[data-extra-question]').textContent='Do you need another pad?';status.textContent='Pad added.';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));
        if(window.theme.pageType==='cart')location.reload();
      } catch(error){status.textContent=error.message;} finally{pending=false;update(false);}
    });
    update(false);
  }
  function scan() { document.querySelectorAll('[data-rugi-cart-protection]').forEach(init); document.querySelectorAll('[data-rugi-extra-pads]').forEach(initExtra); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  var pending;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(scan, 60); }).observe(document.documentElement, { childList: true, subtree: true });
})();






(function () {
  var timer, running = false, again = false;
  function applyCart(cart) {
    document.querySelectorAll('[data-rugi-offer-product]').forEach(function (button) {
      var present = cart.items.some(function (item) { return String(item.product_id) === button.dataset.rugiOfferProduct && item.quantity > 0; });
      button.hidden = present;
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      var form = panel && panel.closest('form');
      if (form) form.toggleAttribute('data-rugi-cart-hidden', present);
      if (present && panel) { panel.hidden = true; button.setAttribute('aria-expanded', 'false'); }
    });
  }
  async function refreshOffers() {
    var button = document.querySelector('[data-rugi-offer-product]');
    if (!button) return;
    if (running) { again = true; return; }
    running = true;
    try {
      var response = await fetch(button.dataset.rugiCartUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (response.ok) applyCart(await response.json());
    } catch (error) {} finally { running = false; if (again) { again = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refreshOffers, 100); }
  ['cart:refresh', 'cart:updated', 'cart:change', 'shopify:section:load'].forEach(function (event) { document.addEventListener(event, schedule); });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  new MutationObserver(function (changes) {
    if (changes.some(function (change) {
      if (change.target.nodeType === 1 && change.target.closest('.mini-cart, .cart-wrapper')) return true;
      return Array.from(change.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('.mini-cart') || node.querySelector('.mini-cart')); });
    })) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();

